import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";

const CarriersSection = () => {
  const { language } = useLanguage();

  const carriers = [
    { name: "Orange", color: "#FF7900" },
    { name: "SFR", color: "#E4002B" },
    { name: "Bouygues", color: "#009DDB" },
    { name: "Free", color: "#CD1E25" },
  ];

  return (
    <section className="calli-section bg-gradient-to-b from-gray-900 to-gray-800 text-white relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)', backgroundSize: '32px 32px'}}></div>
      </div>
      
      <div className="calli-container relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12 space-y-4">
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 rounded-full text-sm font-bold">
              📶 {language === 'fr' ? 'Connectivité' : 'Connectivity'}
            </span>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-black">
              {language === 'fr' ? 'Compatible avec tous les opérateurs' : 'Works with all carriers'}
            </h2>
            <p className="text-lg text-gray-300 max-w-2xl mx-auto">
              {language === 'fr' 
                ? "Insérez simplement une carte SIM avec le forfait de votre choix. Calli fonctionne avec n'importe quel opérateur mobile."
                : "Simply insert a SIM card with any plan you choose. Calli works with any mobile carrier."}
            </p>
          </div>

          {/* Carrier logos */}
          <div className="flex flex-wrap justify-center items-center gap-6 mb-12">
            {carriers.map((carrier, i) => (
              <div 
                key={i}
                className="flex items-center justify-center w-28 h-16 bg-white rounded-xl shadow-lg hover:scale-110 transition-transform"
              >
                <span 
                  className="text-xl font-black"
                  style={{ color: carrier.color }}
                >
                  {carrier.name}
                </span>
              </div>
            ))}
            <div className="flex items-center justify-center w-28 h-16 bg-white/10 border-2 border-dashed border-white/30 rounded-xl">
              <span className="text-sm text-gray-400 text-center">
                {language === 'fr' ? '+ tous les autres' : '+ all others'}
              </span>
            </div>
          </div>

          {/* Info cards */}
          <div className="grid sm:grid-cols-3 gap-4">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center border border-white/10">
              <div className="text-4xl font-black text-green-400 mb-2">2€</div>
              <p className="text-gray-300 text-sm">
                {language === 'fr' ? 'À partir de 2€/mois avec Free Mobile' : 'From €2/month with Free Mobile'}
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center border border-white/10">
              <div className="text-4xl mb-2">🔓</div>
              <p className="text-gray-300 text-sm">
                {language === 'fr' ? 'Aucun engagement, changez quand vous voulez' : 'No commitment, switch anytime'}
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center border border-white/10">
              <div className="text-4xl mb-2">📱</div>
              <p className="text-gray-300 text-sm">
                {language === 'fr' ? 'Format nano-SIM standard inclus' : 'Standard nano-SIM format included'}
              </p>
            </div>
          </div>

          {/* Extra tip */}
          <div className="mt-8 text-center">
            <p className="text-sm text-gray-400">
              💡 {language === 'fr' 
                ? "Astuce : Prenez un forfait avec appels illimités pour que votre enfant puisse vous joindre sans limite !"
                : "Tip: Get an unlimited calls plan so your child can reach you without limits!"}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CarriersSection;
